import { call, put, select, takeEvery } from "redux-saga/effects";
import { courseActions } from "./courseSlice";
import {
  getAll,
  getById,
  updateById,
  create as createCourse,
  getLessonPlan,
  createLessonPlan,
  deleteLessonPlan,
  updatePrequisites,
  deleteById as deleteCourse,
  createAssessment,
  publishAssessmentChapterToLessonPlan,
  publishAssessmentSectionToLessonPlan,
  getAssessmentById,
  deleteAssessment,
  publishAssessmentToCourse,
  updateAssessmentById,
  updateLessonPlan,
  getCourseList,
  getNextCourse,
} from "./courseBaseApi";
import { toastAction } from "../toast/toast";

export function* onChangeCourses(payload) {
  try {
    const { data } = yield call(getAll, payload);
    yield put(courseActions.setCourses(data || {}));
  } catch (error) {
    yield put(courseActions.setCourses({}));
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onGetCourses(payload) {
  try {
    const { category, pageNo } = payload.payload;
    const state = yield select();
    const lastPage = state.course.lastPage[category];

    // Avoid API call if lastPage is reached
    if (lastPage) {
      return;
    }

    const { data, last } = yield call(getCourseList, payload?.payload);
    yield put(
      courseActions.setCoursesList({
        data: data?.data,
        type: category,
        lastPage: data?.last,
      }),
    );
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onChangeCurrentCourse({ payload }) {
  try {
    const { data } = yield call(getById, payload);
    yield put(courseActions.setCurrentCourse(data || {}));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message));
  }
}

export function* onSaveCurrentCourse({ payload }) {
  let { course, navigate } = payload;
  try {
    const { data, message } = yield call(updateById, course);
    yield put(courseActions.setCurrentCourse(data || {}));
    try {
      navigate("/courses", { replace: true });
    } catch (e) {}
    yield put(toastAction.onSuccToast(message));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}
export function* onCreateCourse({ payload }) {
  let { course, navigate } = payload;
  try {
    const { data, message } = yield call(createCourse, course);
    yield put(toastAction.onSuccToast(message));
    // yield put(courseActions.appendCourse(data));
    try {
      navigate("/courses", { replace: true });
    } catch (e) {}
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onDeleteCourse({ payload }) {
  try {
    yield put(courseActions.deleteCourse(payload));

    const { data, message } = yield call(deleteCourse, payload);
    yield put(toastAction.onSuccToast(message));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onLessonPlanLoad({ payload }) {
  try {
    const { data, message } = yield call(getLessonPlan, payload);
    let { lessonPlan, id, courseId, courseCode, status, assessments } = data;
    yield put(
      courseActions.setLessonPlan({
        ...lessonPlan,
        id,
        courseId,
        status,
        courseCode,
        assessments,
      }),
    );
  } catch (error) {
    if (error.errorCode === 500) {
      yield put(courseActions.setLessonPlan({ courseId: payload.id }));
    } else {
      yield put(courseActions.setLessonPlan({ courseId: payload.id }));
      yield put(toastAction.onErrorToast(error.message || error.error));
    }
  }
}

export function* onLessonPlanCreate({ payload }) {
  try {
    const { data, message } = yield call(createLessonPlan, payload);
    let { lessonPlan, id } = data;

    yield put(toastAction.onSuccToast(`Lesson Plan Create Success`));
    yield put(courseActions.setLessonPlan({ ...lessonPlan, id }));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onLessonPlanDelete({ payload }) {
  try {
    const { data, message } = yield call(deleteLessonPlan, payload);
    yield put(courseActions.setLessonPlan({ id: null }));
    yield put(toastAction.onSuccToast(`Lesson Plan Delete Success`));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onPrerequisitesChange({ payload }) {
  try {
    const { data, message } = yield call(updatePrequisites, payload);
    yield put(courseActions.updatePrerequisites(payload.prerequistes || {}));
    yield put(toastAction.onSuccToast(message));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onCreateAssessment({ payload }) {
  let { assessment, navigate } = payload;
  try {
    const { data, message } = yield call(createAssessment, assessment);
    yield put(toastAction.onSuccToast(message));
    // yield put(courseActions.appendCourse(data));
    try {
      navigate("/courses", { replace: true });
    } catch (e) {}
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onDeleteAssessment({ payload }) {
  try {
    // yield put(courseActions.deleteAssessment(payload));
    const { data, message } = yield call(deleteAssessment, payload);
    yield put(toastAction.onSuccToast(message));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onSaveCurrentAssessment({ payload }) {
  let { assessment } = payload;
  try {
    const { data, message } = yield call(updateAssessmentById, assessment);
    yield put(courseActions.setCurrentCourse(data || {}));
    yield put(toastAction.onSuccToast(message));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onPublishAssessmentChapterToLessonPlan({ payload }) {
  let { assessment } = payload;
  // let { assessment, navigate,path } = payload;
  try {
    const { data, message } = yield call(
      publishAssessmentChapterToLessonPlan,
      assessment,
    );
    // yield put(toastAction.onSuccToast(message))
    // yield put(courseActions.appendCourse(data));
    try {
      yield put(toastAction.onSuccToast("Assessment Added Successfully"));
      // navigate(path || '/courses', { replace: true });
    } catch (e) {}
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onPublishAssessmentSectionToLessonPlan({ payload }) {
  let { assessment } = payload;
  // let { assessment, navigate,path } = payload;
  try {
    const { data, message } = yield call(
      publishAssessmentSectionToLessonPlan,
      assessment,
    );
    // yield put(toastAction.onSuccToast(message))
    // yield put(courseActions.appendCourse(data));
    try {
      yield put(toastAction.onSuccToast("Assessment Added Successfully"));
      // navigate(path||'/courses', { replace: true });
    } catch (e) {}
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onPublishAssessmentToCourse({ payload }) {
  let { assessment } = payload;
  // let { assessment, navigate,path } = payload;
  try {
    const { data, message } = yield call(publishAssessmentToCourse, assessment);
    yield put(toastAction.onSuccToast("Assessment Added Successfully"));
    // yield put(courseActions.appendCourse(data));
    try {
      yield put(toastAction.onSuccToast(message));
      // navigate(path||'/courses', { replace: true });
    } catch (e) {}
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onChangeCurrentAssessment({ payload }) {
  try {
    const { data } = yield call(getAssessmentById, payload);
    yield put(courseActions.setCurrentAssessment(data || {}));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message));
  }
}

export function* onSaveCurrentLessonPlan({ payload }) {
  try {
    const { data, message } = yield call(updateLessonPlan, payload);
    // yield put(courseActions.setCurrentCourse(data || {}));
    yield put(toastAction.onSuccToast(`Lesson Plan Update Success`));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onGetNextCourse({ payload }) {
  try {
    const { data } = yield call(getNextCourse, payload);
    yield put(courseActions.setNextCourse(data || {}));
    // yield put(toastAction.onSuccToast('Successfully retrived next course'));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

// export function* onGenerateQuestion ({payload}){
//     try{
//         const {data,message} = yield call(generateQuestion,payload);
//     }catch(error){
//         yield put(toastAction.onErrorToast(error?.message))
//     }
// }

function* courseWatcherSaga() {
  yield takeEvery(courseActions.loadCourses.type, onChangeCourses);
  yield takeEvery(courseActions.loadCoursesList.type, onGetCourses);
  yield takeEvery(courseActions.loadCurrentCourse.type, onChangeCurrentCourse);
  yield takeEvery(courseActions.saveCurrentCourse.type, onSaveCurrentCourse);
  yield takeEvery(courseActions.createCourse.type, onCreateCourse);
  yield takeEvery(courseActions.removeCourse.type, onDeleteCourse);
  yield takeEvery(courseActions.loadLessonPlan.type, onLessonPlanLoad);
  yield takeEvery(courseActions.deleteLessonPlan.type, onLessonPlanDelete);
  yield takeEvery(courseActions.createLessonPlan.type, onLessonPlanCreate);
  yield takeEvery(
    courseActions.saveCurrentLessonPlan.type,
    onSaveCurrentLessonPlan,
  );
  yield takeEvery(courseActions.savePrequisites.type, onPrerequisitesChange);
  yield takeEvery(courseActions.createAssessment.type, onCreateAssessment);
  yield takeEvery(courseActions.deleteAssessment.type, onDeleteAssessment);
  yield takeEvery(
    courseActions.saveCurrentAssessment.type,
    onSaveCurrentAssessment,
  );
  yield takeEvery(
    courseActions.publishAssessmentChapterToLessonPlan.type,
    onPublishAssessmentChapterToLessonPlan,
  );
  yield takeEvery(
    courseActions.publishAssessmentSectionToLessonPlan.type,
    onPublishAssessmentSectionToLessonPlan,
  );
  yield takeEvery(
    courseActions.publishAssessmentToCourse.type,
    onPublishAssessmentToCourse,
  );
  yield takeEvery(
    courseActions.loadCurrentAssessment.type,
    onChangeCurrentAssessment,
  );
  yield takeEvery(courseActions.loadNextCourse.type, onGetNextCourse);
  // yield takeEvery(courseActions.LoadGeneratedQuestions.type,onGenerateQuestion);
}

export default courseWatcherSaga;
